import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _410_45global from "/app/middleware/410.global.ts";
import close_45global from "/app/middleware/close.global.ts";
import route_45guard_45global from "/app/middleware/routeGuard.global.ts";
import whitelabel_45global from "/app/middleware/whitelabel.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _410_45global,
  close_45global,
  route_45guard_45global,
  whitelabel_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}